import { clickEater } from '../../uiParts/clickEater-sidecar'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { echoFonts } from '../echo/echoFonts-sidecar'
import { voyageCamera } from './voyageCamera-sidecar'
import { voyageGameManager } from './voyageGameManager-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import type { IVoyageUiCanvas } from './voyageUiCanvas'
import { voyageUiCanvas } from './voyageUiCanvas-sidecar'
import { voyageUiGButtons } from './voyageUiGButtons-sidecar'
import { voyageUiMessage } from './voyageUiMessage-sidecar'

interface IVoyageMenuMain extends IVoyageUiCanvas {
  //spriteBackground: PImage
}

let _obj: IVoyageMenuMain | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setOpen(false)
    setBackgroundOpen(false)
    render()
  }
  return _obj
}

const create = () => {
  // TODO: new sprite
  // let sprite = largeSprites.goatBackgroundMenuMain

  // let spriteBackground = spritesUtil.createLargeSprite(
  //   voyageLayers.getLayers().uiMenuMain,
  //   sprite,
  // )

  // let tw = 1920 - 100
  // let th = 1080 - 200

  let tw = 400
  let th = 300

  let canvas = voyageUiCanvas.create(
    tw,
    th,
    voyageLayers.getLayers().uiMenuMain,
  )
  canvas.autoOffset = false
  canvas.ox = 170 //1000
  canvas.oy = 240

  let obj: IVoyageMenuMain = voyageUiCanvas.assign<IVoyageMenuMain>(canvas, {
    //spriteBackground,
  })

  let x = 20
  let y = 40
  const addButton = (text: string, action: () => void) => {
    let button = voyageUiGButtons.create(text, x, y, action)
    button.w = 160
    obj.buttons.push(button)
    y += 100
  }

  addButton('New Voyage', () => {
    setOpen(false)
    setBackgroundOpen(false)

    voyageGameManager.goGame()
  })

  addButton('Credits', () => {
    // \n\nAdditional Testing:

    let text = ''
    text += 'Designed and programmed by\n Stevie Bushman'
    text += '\n Keep Flying Games'
    text += '\n https://keepflyinggames.com'
    text += '\n\nAdditional sound effects from\n https://www.zapsplat.com'
    text +=
      '\n\nAdditional sound effects licensed from\n https://cafofomusic.itch.io'
    text +=
      "\n\nShip design inspired by\n Lazarus' Gabriel Fallen\n https://gm-lazarus.itch.io/gabriel-fallen"
    voyageUiMessage.setText('Credits', text)
    voyageUiMessage.setOpen(true)
  })

  addButton('v1.05 News', () => {
    // \n\nAdditional Testing:
    let text = ''
    text += '\n1.05 5/5/2021'
    text += '\n- add battle rifles'
    text += '\n- add coffee'
    text += '\n\n1.04 5/5/2021'
    text += '\n- flip star movement direction XD'
    text += '\n- add selection rectangle'
    text += '\n\n1.03 5/4/2021'
    text += '\n- zoom in / out with mouse wheel'
    text += '\n- pause with space'
    text += '\n\n1.02 5/3/2021'
    text += '\n- tutorial step for breach/fire'
    text += '\n\n1.01 5/3/2021'
    text += '\n- added flavor text for professions'
    text += '\n- death screen, basic ui fixes'
    text += '\n- decor'

    text += '\n\n1.00 5/3/2021'
    text += '\n- jam release'
    voyageUiMessage.setText('News', text)
    voyageUiMessage.setOpen(true)
  })

  addButton('Website', () => {
    window.open('https://keepflyinggames.com')
  })

  // addButton('Early Access', () => {
  //   goatUiMessage.setText(
  //     'Early Access',
  //     'You may encounter bugs and things may change!',
  //   )
  //   goatUiMessage.setOpen(true)
  // })

  return obj
}

const render = () => {
  let obj = get()
  let g = obj.graphics

  voyageUiCanvas.clear(obj)

  let addText = (text: string, x: number, y: number) => {
    let _text = stevieTexts2.create(echoFonts.getData().font6, x, y, obj.layer)
    stevieTexts2.setText(_text, text)
    stevieTexts2.setScale(_text, 3)

    obj.texts.push(_text)
    return _text
  }

  let x = 0
  let y = 0
  let w = 200
  let h = 400

  // voyageUiGraphicsUtils.bevelPanel(g, x, y, w, h)
  // addText('Main Menu', x + 6, y) // + 25 - 2)

  x = 300 + 20
  y = 0
  w = 1000 - 20
  h = 400

  voyageUiCanvas.render(obj)
}

export const setOpen = (isOpen: boolean) => {
  let obj = get()
  voyageUiCanvas.setOpen(obj, isOpen)
  if (isOpen) {
    setBackgroundOpen(true)
  }
  update()
}

export const setBackgroundOpen = (isOpen: boolean) => {
  let obj = get()
  // obj.spriteBackground.visible = isOpen
  // obj.spriteBackground.visible = false
}

export const update = () => {
  let obj = get()

  if (obj.isOpen) {
    let gb = voyageCamera.getGameBounds()

    // Adjust background image
    {
      let bw = 3440
      let bh = 1440

      let ox = (gb.width - bw) / 2
      let oy = (gb.height - bh) / 2

      // obj.spriteBackground.scale = 1
      // obj.spriteBackground.x = ox
      // obj.spriteBackground.y = oy
    }

    voyageUiCanvas.update(obj)
    render()
    clickEater.tempEatCursor()
  } else {
    voyageUiCanvas.clear(obj)
  }
}
